import React, { useMemo, useCallback, useState, Fragment, useEffect } from 'react';
import { P, Span, Box, Avatar, Loading, Button, Icon, Clickable, H6, H5, Tooltip, Widget, ListGrid, H2, useTabState, TabList, Tab, TabPanel, Text } from '@maui/elements';
import { DescriptionList } from '@maui/patterns-description-list';
import { ResponsivePie } from '@nivo/pie';
import { openModal, formatBytes } from '@horizon/utilities';
import { normalizeIndicator, normalizeFile, normalizeCase, normalizeReport as normalizeReport$1, File } from '@horizon/components-file';
import { useQuery, useQueryClient, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEodDrawer, useEodCallback } from '@horizon/hooks';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CSVLink } from 'react-csv';
import filesize from 'filesize';
import { Score } from '@maui/score';
import { ActorDetails, CampaignDetails, MalwareDetails, AssociationsDetails } from '@horizon-shared/indicator-details';
import { useAuthProvider } from '@maui-mf/common-react';
import { WindowScroller, AutoSizer, List } from 'react-virtualized';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

var INDICATOR_TYPES = [
    ['connections', 'Connections', 'network'],
    ['http', 'HTTP', 'network'],
    ['file', 'File', 'host'],
    ['directory', 'Directory', 'host'],
    ['windows-registry', 'Windows Registry', 'host'],
    ['process', 'Process', 'host'],
    ['mutex', 'Mutex', 'host'],
];
var getIndicatorsByType = function (indicatorType) {
    return INDICATOR_TYPES.filter(function (_a) {
        var type = _a[2];
        return type === indicatorType;
    });
};
var INDICATOR_NAVIGATION_ITEMS = [
    ['Network', getIndicatorsByType('network')],
    ['Host', getIndicatorsByType('host')],
];
var INDICATOR_SLUG_MAP = INDICATOR_TYPES.reduce(function (acc, group) {
    var slug = group[0], label = group[1];
    acc[slug] = label;
    return acc;
}, {});
// @ts-ignore
var ENV = window.__maui_mf_env__ || {
    REACT_APP_API_HOST: "https://qa-api-advantage.mandiant.com"
};

var MAUI_AUTH_KEY = 'maui-mf-common-auth:store';
var getAuthHeaders = function () {
    var _a;
    var authStore = JSON.parse((_a = localStorage.getItem(MAUI_AUTH_KEY)) !== null && _a !== void 0 ? _a : '{}');
    return {
        Authorization: "Bearer ".concat(authStore === null || authStore === void 0 ? void 0 : authStore.token),
    };
};
var fetch = function (pathname, init) {
    if (init === void 0) { init = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var url, options;
        return __generator(this, function (_a) {
            url = new URL(pathname, ENV.REACT_APP_API_HOST);
            options = __assign(__assign({}, init), { headers: __assign(__assign({}, (init.headers || {})), getAuthHeaders()) });
            return [2 /*return*/, window.fetch(url, options).then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!res.ok) {
                                    throw new Error(res.status.toString());
                                }
                                return [4 /*yield*/, res.json()];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                }); })];
        });
    });
};

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */

function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}

/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */

function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result; // Check for the difference of less than month

  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }

    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value

    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month

    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }

    result = sign * (difference - Number(isLastMonthNotFull));
  } // Prevent negative zero


  return result === 0 ? 0 : result;
}

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}

var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function (value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE

};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */

function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance$1 = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

var formatDistance$2 = formatDistance$1;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // TODO: Remove String()

    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

var formatRelative$1 = formatRelative;

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance$2,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

function cloneObject(dirtyObject) {
  return assign({}, dirtyObject);
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;
/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `distanceInWords ` to `formatDistance`
 *   to make its name consistent with `format` and `formatRelative`.
 *
 * - The order of arguments is swapped to make the function
 *   consistent with `differenceIn...` functions.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   distanceInWords(
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     new Date(1986, 3, 4, 11, 32, 0),
 *     { addSuffix: true }
 *   ) //=> 'in about 1 hour'
 *
 *   // v2.0.0 onward
 *
 *   formatDistance(
 *     new Date(1986, 3, 4, 11, 32, 0),
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     { addSuffix: true }
 *   ) //=> 'in about 1 hour'
 *   ```
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */

function formatDistance(dirtyDate, dirtyBaseDate) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  requiredArgs(2, arguments);
  var locale = options.locale || defaultLocale;

  if (!locale.formatDistance) {
    throw new RangeError('locale must contain formatDistance property');
  }

  var comparison = compareAsc(dirtyDate, dirtyBaseDate);

  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }

  var localizeOptions = cloneObject(options);
  localizeOptions.addSuffix = Boolean(options.addSuffix);
  localizeOptions.comparison = comparison;
  var dateLeft;
  var dateRight;

  if (comparison > 0) {
    dateLeft = toDate(dirtyBaseDate);
    dateRight = toDate(dirtyDate);
  } else {
    dateLeft = toDate(dirtyDate);
    dateRight = toDate(dirtyBaseDate);
  }

  var seconds = differenceInSeconds(dateRight, dateLeft);
  var offsetInSeconds = (getTimezoneOffsetInMilliseconds(dateRight) - getTimezoneOffsetInMilliseconds(dateLeft)) / 1000;
  var minutes = Math.round((seconds - offsetInSeconds) / 60);
  var months; // 0 up to 2 mins

  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance('halfAMinute', null, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', minutes, localizeOptions);
      }
    } // 2 mins up to 0.75 hrs

  } else if (minutes < 45) {
    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('aboutXMonths', months, localizeOptions);
  }

  months = differenceInMonths(dateRight, dateLeft); // 2 months up to 12 months

  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12;
    var years = Math.floor(months / 12); // N years up to 1 years 3 months

    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
    } else {
      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
  }
}

var formatDistanceDate = function (dateString) {
    return formatDistance(new Date(dateString), new Date(), {
        addSuffix: true,
    });
};

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$2 = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var lightFormatters = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var formatters$1 = formatters;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

var formatMediumDate = function (dateString) {
    return format(new Date(dateString), 'yyyy-MM-dd hh:mm:ss');
};

var formatShortDate = function (rawDate) {
    var options = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' };
    return new Date(rawDate).toLocaleDateString(undefined, options);
};

var IPV4_REGEX = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi;
var IPV6_REGEX = /^((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*::((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*|((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4})){7}$/gi;
var getNetworkIndicatorName = function getNetworkIndicatorName(indicator) {
  var value = indicator.value;

  if (indicator.isIP) {
    if (value.match(IPV4_REGEX)) {
      return 'ipv4';
    }

    if (value.match(IPV6_REGEX)) {
      return 'ipv6';
    }

    if (value.toLowerCase().startsWith('http') || value.includes('/')) {
      return 'url';
    }
  }

  try {
    var normalizedValue = value.toLowerCase().startsWith('http') ? value : "http://".concat(value);

    var _ref = new URL(normalizedValue) || {},
        hash = _ref.hash,
        port = _ref.port,
        pathname = _ref.pathname;

    if (normalizedValue.endsWith('/') || hash || port || pathname !== '/') {
      return 'url';
    }
  } catch (_unused) {
    return 'fqdn';
  }

  return 'fqdn';
};

var createIndicatorHeaders = function createIndicatorHeaders(includeWindowsRegistryHeaders) {
  var headers = ['Indicator Value', 'Indicator Value Data', 'Indicator Type', 'IC-Score'];

  if (!includeWindowsRegistryHeaders) {
    return headers.filter(function (_, idx) {
      return idx !== 1;
    });
  }

  return headers;
};

var indicatorsToCsv = function indicatorsToCsv() {
  var indicators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fetchedIndicators = arguments.length > 1 ? arguments[1] : undefined;
  var includeWindowsRegistryHeaders = indicators.some(function (indicator) {
    return indicator.name === 'windows-registry';
  });
  return indicators.reduce(function (acc, type) {
    var _INDICATOR_SLUG_MAP$i;

    var _type$items = type.items,
        items = _type$items === void 0 ? [] : _type$items,
        indicatorType = type.name;
    var name = ((_INDICATOR_SLUG_MAP$i = INDICATOR_SLUG_MAP[indicatorType]) === null || _INDICATOR_SLUG_MAP$i === void 0 ? void 0 : _INDICATOR_SLUG_MAP$i.toUpperCase()) || 'Unknown';

    var getRow = function getRow(item) {
      var _fetchedIndicators$it, _fetchedIndicators$it2;

      if (Array.isArray(item === null || item === void 0 ? void 0 : item.items)) {
        return item.items.forEach(getRow);
      }

      var getValueData = function getValueData() {
        if (indicatorType === 'windows-registry') {
          return item.key;
        }

        return '';
      };

      var getIndicatorName = function getIndicatorName() {
        if (indicatorType === 'http' || indicatorType === 'connections') {
          return getNetworkIndicatorName(item).toUpperCase();
        }

        return name;
      };

      var mscore = (_fetchedIndicators$it = (_fetchedIndicators$it2 = fetchedIndicators[item.value]) === null || _fetchedIndicators$it2 === void 0 ? void 0 : _fetchedIndicators$it2.mscore) !== null && _fetchedIndicators$it !== void 0 ? _fetchedIndicators$it : '';

      if (includeWindowsRegistryHeaders) {
        return acc.push([item.value, getValueData(), getIndicatorName(), mscore]);
      }

      return acc.push([item.value, getIndicatorName(), mscore]);
    };

    items.forEach(getRow);
    return acc;
  }, [createIndicatorHeaders(includeWindowsRegistryHeaders)]);
};

var AnalysisDetails = function (_a) {
    var analysisDate = _a.analysisDate, owner = _a.owner, detections = _a.detections;
    return (React.createElement(DescriptionList, { marginTop: "0", marginBottom: "0" },
        analysisDate && (React.createElement(DescriptionList.Section, { marginBottom: "0", paddingBottom: "spaceGapSmall" },
            React.createElement(DescriptionList.Term, null,
                React.createElement(P, { margin: "0" }, "Analysis Date")),
            React.createElement(DescriptionList.Details, null,
                React.createElement(P, { margin: "0" },
                    React.createElement(Span, { textStyle: "bodySmall" }, formatMediumDate(analysisDate)),
                    " \u00A0",
                    React.createElement(Span, { textStyle: "bodySmall", color: "colorTextDeemphasis" },
                        "(",
                        formatDistanceDate(analysisDate),
                        ")"))))),
        owner && (React.createElement(DescriptionList.Section, { marginBottom: "0", paddingBottom: "spaceGapSmall" },
            React.createElement(DescriptionList.Term, null,
                React.createElement(P, { margin: "0" }, "Submitted by")),
            React.createElement(DescriptionList.Details, null,
                React.createElement(P, { margin: "0" },
                    React.createElement(Box, { display: "flex", alignItems: "center", gap: "spaceGapMedium" },
                        React.createElement(Avatar, { flexShrink: 0, width: "14px", height: "14px", fontSize: "8px", fontWeight: "700" }, owner.initials),
                        owner.name))))),
        detections && (detections === null || detections === void 0 ? void 0 : detections.length) > 0 && (React.createElement(DescriptionList.Section, { marginBottom: "0", paddingBottom: "spaceGapSmall" },
            React.createElement(DescriptionList.Term, null,
                React.createElement(P, { margin: "0" }, "Detections")),
            React.createElement(DescriptionList.Details, null, detections.map(function (detection, idx) { return (React.createElement(P, { marginTop: "0", marginBottom: "spaceGapSmall", key: idx },
                detection,
                " ",
                React.createElement("br", null))); }))))));
};

var chartColors = [
    '#C74A37',
    '#5F986A',
    '#965AA9',
    '#4A9BBC',
    '#DE8E47',
    '#C24976',
    '#F0DF6D',
    '#73C4AC',
    '#939FB2',
    '#CC00FF',
];
var CenteredMetric = function (_a) {
    var centerX = _a.centerX, centerY = _a.centerY, centerText = _a.centerText, props = __rest(_a, ["centerX", "centerY", "centerText"]);
    var textSize = props.innerRadius < 70 ? '16px' : '30px';
    return (React.createElement("text", { x: centerX, y: centerY, textAnchor: "middle", dominantBaseline: "central", style: {
            fontSize: textSize,
            fontWeight: 600,
            fill: '#e8e8e8',
        } }, centerText));
};
var tooltip = function (_a) {
    var label = _a.label, value = _a.value, color = _a.color, data = _a.data;
    var textColor = ['#F0DF6D', '#73C4AC'].includes(color) ? 'colorTextReverse' : 'colorTextMain';
    return (React.createElement(Box, { position: "absolute", paddingTop: "spaceGapSmall", paddingBottom: "spaceGapSmall", paddingLeft: "spaceGapMedium", paddingRight: "spaceGapMedium", top: "-15px", left: "spaceGapMedium", backgroundColor: color, color: textColor, borderWidth: "2px", borderStyle: "solid", borderColor: "colorTextMain", borderRadius: "radiusMedium", whiteSpace: "nowrap" },
        (data === null || data === void 0 ? void 0 : data.displayLabel) || label,
        ": ",
        parseFloat(value)));
};
var commonProperties = {
    id: 'label',
    margin: {
        top: 16,
        right: 120,
        bottom: 16,
        left: 16,
    },
    animate: true,
    colors: chartColors,
    cursor: 'pointer',
    enableArcLabels: false,
    enableArcLinkLabels: false,
    innerRadius: 0.85,
    padAngle: 1,
    theme: { textColor: 'colorTextMain' },
    activeOuterRadiusOffset: 8,
    tooltip: function (_a) {
        var datum = _a.datum;
        return tooltip(datum);
    },
    onMouseEnter: function (_, event) {
        event.currentTarget.style.cursor = 'pointer';
    },
};
var DonutChart = function (_a) {
    var data = _a.data, height = _a.height, onClick = _a.onClick, centerText = _a.centerText;
    return (data && (React.createElement(Box, { height: height },
        React.createElement(ResponsivePie, __assign({ data: data }, commonProperties, { layers: [
                'arcs',
                'legends',
                function (props) { return React.createElement(CenteredMetric, __assign({}, props, { centerText: centerText })); },
            ], onClick: function (data) { return onClick(data); }, legends: [
                {
                    anchor: 'right',
                    dataFrom: 'keys',
                    direction: 'column',
                    itemHeight: 16,
                    itemsSpacing: 8,
                    itemWidth: 125,
                    itemTextColor: '#e8e8e8',
                    itemTextSize: '16px',
                    symbolSize: 12,
                    symbolShape: function (_a) {
                        var fill = _a.fill;
                        return React.createElement("rect", { y: "4", width: "12", height: "8", rx: "2", fill: fill });
                    },
                    translateX: 120,
                    onClick: function (data) { return onClick(data); },
                    cursor: 'pointer',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemTextColor: '#98bef0',
                            },
                        },
                    ],
                },
            ] })))));
};

var Analyzing = function () { return (React.createElement(Box, { marginTop: "spaceGapLarge" },
    React.createElement(Loading, { size: "small", label: "Analysis in Progress" }))); };

var useNormalizedHashes = function (indicator, report, file) {
    return useMemo(function () {
        if (report === null || report === void 0 ? void 0 : report.md5) {
            var md5 = report.md5, sha1 = report.sha1, sha256 = report.sha256;
            return {
                md5: md5,
                sha1: sha1,
                sha256: sha256,
            };
        }
        if (indicator === null || indicator === void 0 ? void 0 : indicator.associated_hashes) {
            return indicator === null || indicator === void 0 ? void 0 : indicator.associated_hashes.reduce(function (acc, hash) {
                var type = hash.type;
                acc[type] = hash.value;
                return acc;
            }, {});
        }
        if (file === null || file === void 0 ? void 0 : file.md5) {
            var sha1 = file.sha1, sha256 = file.sha256, md5 = file.md5;
            return {
                sha1: sha1,
                sha256: sha256,
                md5: md5
            };
        }
        return {};
    }, [indicator, report, file]);
};

var useHashDetails = function (_a) {
    var indicator = _a.indicator, hash = _a.hash;
    var hashType = useHashType((indicator === null || indicator === void 0 ? void 0 : indicator.value) || hash);
    var _b = useReport((indicator === null || indicator === void 0 ? void 0 : indicator.value) || hash), report = _b.report, fetchingReport = _b.isFetching;
    var file = useFile((indicator === null || indicator === void 0 ? void 0 : indicator.value) || hash, hashType).file;
    var hashes = useNormalizedHashes(indicator, report, file);
    var analyzing = useMemo(function () {
        return (report === null || report === void 0 ? void 0 : report.status) === 'ANALYZING';
    }, [report]);
    var notFound = useMemo(function () {
        if (indicator === null && !report) {
            return true;
        }
        if (Object.keys(indicator || {}).length === 2 && !report) {
            return true;
        }
        return false;
    }, [indicator, report]);
    var loading = useMemo(function () {
        return fetchingReport || indicator === undefined;
    }, [indicator, fetchingReport]);
    return {
        notFound: notFound,
        loading: loading,
        report: report,
        file: file,
        hashes: hashes,
        analyzing: analyzing,
    };
};

var fetchActorById = function (id) {
    return fetch("/api/v4/actor/".concat(id), {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};

var fetchArchiveContentsById = function (id) {
    return fetch("/api/v4/files/".concat(id), {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};

var fetchCaseBySha256 = function (sha256) {
    return fetch("/eod/cases?attachment_id=".concat(sha256), {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};

var fetchFileByHash = function (hash, type) {
    return fetch("/api/v4/files?corpora=org&filter=".concat(type, "&value=").concat(hash), {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};

var fetchIndicatorByMd5 = function (md5) {
    var params = [
        "explainer=true",
        "include_campaigns=true"
    ];
    return fetch("/api/v4/indicator/md5/".concat(md5, "?").concat(params.join('&')), {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};

var fetchIndicatorsByValues = function (values) {
    return fetch('/api/v4/indicator', {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            requests: [
                {
                    values: values,
                },
            ],
        }),
        method: 'POST',
    });
};

var fetchReportByHash = function (hash) {
    return fetch("/api/v4/files/report/".concat(hash), {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};

var useIndicator = function (md5) {
    var _a = useQuery(['indicator', md5], function () { return fetchIndicatorByMd5(md5); }), data = _a.data, rest = __rest(_a, ["data"]);
    var indicator = useMemo(function () {
        if (!data) {
            return;
        }
        return normalizeIndicator(data);
    }, [data]);
    return __assign({ indicator: indicator }, rest);
};

var useIndicators = function (values) {
    if (values === void 0) { values = []; }
    var _a = useQuery(['indicators', values.join(', ')], function () { return fetchIndicatorsByValues(values.slice(0, 100)); }, {
        enabled: values.length > 0,
    }), data = _a.data, isLoading = _a.isLoading, rest = __rest(_a, ["data", "isLoading"]);
    var indicators = useMemo(function () {
        if (isLoading) {
            return;
        }
        var initialAcc = values.reduce(function (acc, value) {
            acc[value] = null;
            return acc;
        }, {});
        if (!data) {
            return initialAcc;
        }
        return data.indicators.reduce(function (acc, indicator) {
            acc[indicator.value] = indicator;
            return acc;
        }, initialAcc);
    }, [data, isLoading]);
    return __assign({ indicators: indicators, isLoading: isLoading }, rest);
};

var processors = function () {
    var cache = {};
    var indexes = {};
    var storeValue = function (target, value, key) {
        if (cache[key])
            return;
        target.push(value);
        cache[key] = true;
    };
    var detection = function (target, data) {
        var malwareFamily = data["malware-family"];
        storeValue(target, malwareFamily, "detection/".concat(malwareFamily));
    };
    var network = function (target, data) {
        var _a;
        var ipv4 = data.ipv4, ipv6 = data.ipv6, _b = data.path, path = _b === void 0 ? null : _b, _c = data.port, port = _c === void 0 ? null : _c;
        if ((_a = data === null || data === void 0 ? void 0 : data.host) === null || _a === void 0 ? void 0 : _a.startsWith('http')) {
            if (!('http' in indexes)) {
                var idx = target.push({
                    name: 'http',
                    type: 'indicator-type',
                    items: [],
                });
                indexes.http = idx - 1;
            }
            var value = data.host;
            return storeValue(target[indexes.http].items, {
                value: value,
                isIP: false,
                type: 'URL',
                queryable: true,
            }, "network/http/".concat(value));
        }
        if (((data === null || data === void 0 ? void 0 : data.host) || ipv4 || ipv6) && typeof path === 'string') {
            if (!('http' in indexes)) {
                var idx = target.push({
                    name: 'http',
                    type: 'indicator-type',
                    items: [],
                });
                indexes.http = idx - 1;
            }
            var host_1 = data.host || ipv4 || ipv6;
            var protocol = port === 443 || port === 8443 ? 'https' : 'http';
            var value = "".concat(protocol, "://").concat(host_1).concat(path.startsWith('/') ? path : "/".concat(path));
            var containsIP_1 = typeof (ipv4 || ipv6) !== 'undefined';
            return storeValue(target[indexes.http].items, {
                value: value,
                isIP: !data.host && containsIP_1,
                type: 'URL',
                queryable: true,
            }, "network/http/".concat(value));
        }
        var host = data.host || ipv4 || ipv6;
        var containsIP = typeof (ipv4 || ipv6) !== 'undefined';
        var isIP = !data.host && containsIP;
        if (!('connections' in indexes)) {
            var idx = target.push({
                name: 'connections',
                type: 'indicator-type',
                items: [],
            });
            indexes.connections = idx - 1;
        }
        var payload = {
            value: host,
            isIP: isIP,
            queryable: true,
        };
        storeValue(target[indexes.connections].items, payload, "network/connections/".concat(payload.value));
    };
    var host = function (hostIndicators, data, subtype) {
        var operation = data.operation;
        var payloadByType = {
            file: function (_a) {
                var path = _a.path;
                return ({
                    value: path,
                    operation: operation,
                    hasParent: true,
                });
            },
            mutex: function (_a) {
                var name = _a.name;
                return ({
                    value: name,
                });
            },
            'windows-registry': function (_a) {
                var value = _a.value, key = _a.key;
                return ({
                    key: key,
                    value: value,
                    operation: operation,
                    hasParent: true,
                });
            },
            directory: function (_a) {
                var name = _a.name;
                return ({
                    value: name,
                });
            },
            process: function (_a) {
                var commandLine = _a["command-line"], name = _a.name;
                return ({
                    value: commandLine === 'N/A' ? name : commandLine || name,
                });
            },
        };
        /**
         * Note:
         * This is a bug on the data side
         */
        if (subtype.match('file|windows-registry') && !operation) {
            return;
        }
        if (!payloadByType[subtype]) {
            return;
        }
        var payload = payloadByType[subtype](data);
        // @ts-ignore
        var keyParts = ['host', subtype, operation, payload.key, payload.value].filter(function (i) { return i !== undefined && i !== null; });
        var key = keyParts.join('/');
        if (!(subtype in indexes)) {
            var idx = hostIndicators.push({
                name: subtype,
                type: 'indicator-type',
                items: [],
            });
            indexes[subtype] = idx - 1;
        }
        if (operation && !(operation in indexes)) {
            var idx = hostIndicators[indexes[subtype]].items.push({
                name: operation,
                type: 'operation',
                items: [],
            });
            indexes[operation] = idx - 1;
        }
        var subtypeIndex = indexes[subtype];
        var operationIndex = operation ? indexes[operation] : -1;
        storeValue(operation
            ? hostIndicators[subtypeIndex].items[operationIndex].items
            : hostIndicators[subtypeIndex].items, payload, key);
    };
    return {
        detection: detection,
        network: network,
        host: host,
    };
};
var getCounts = function (indicators) {
    return indicators.reduce(function (acc, _a) {
        var name = _a.name, _b = _a.items, items = _b === void 0 ? [] : _b;
        if (name.match('file|windows-registry')) {
            items.forEach(function (_a) {
                var _b = _a.items, items = _b === void 0 ? [] : _b;
                acc[name] = name in acc ? acc[name] + items.length : items.length;
            });
        }
        else {
            acc[name] = items.length;
        }
        return acc;
    }, {});
};
var getHorizonVerdict = function (maliciousDetermination, analysisDate) {
    if (!maliciousDetermination) {
        return null;
    }
    var determination = (maliciousDetermination === null || maliciousDetermination === void 0 ? void 0 : maliciousDetermination.toLowerCase()) || '';
    if (determination.includes('unknown') || determination === '') {
        return null;
    }
    return {
        fileAnalysisVerdict: {
            verdict: determination.includes('malicious') ? 'malicious' : 'benign',
            timestamp: analysisDate,
        },
        authoritativeVerdict: 'fileAnalysisVerdict',
    };
};
var convertVerdictToMscore = function (verdict) {
    if (!verdict) {
        return null;
    }
    return verdict === 'malicious' ? 100 : 0;
};
var normalizeReport = function (rawResponse) {
    var _a;
    if (!rawResponse)
        return null;
    var _b = rawResponse.md5, md5 = _b === void 0 ? '' : _b, _c = rawResponse.sha1, sha1 = _c === void 0 ? '' : _c, _d = rawResponse.sha256, sha256 = _d === void 0 ? '' : _d, _e = rawResponse.mimeType, mimeType = _e === void 0 ? 'Not Known' : _e, size = rawResponse.size, _f = rawResponse.indicators, rawIndicators = _f === void 0 ? [] : _f, generatedOn = rawResponse.generated_on, maliciousDetermination = rawResponse.maliciousDetermination, _g = rawResponse.extractedFiles, rawExtractedFiles = _g === void 0 ? [] : _g;
    var isAnalyzing = (rawResponse === null || rawResponse === void 0 ? void 0 : rawResponse.status) === 'SUBMITTED' || (rawResponse === null || rawResponse === void 0 ? void 0 : rawResponse.status) === 'IN_PROGRESS';
    if (isAnalyzing) {
        return {
            status: 'ANALYZING',
            md5: md5,
            sha1: sha1,
            sha256: sha256,
            mimeType: mimeType,
            size: size,
        };
    }
    var analysisDate = (generatedOn === null || generatedOn === void 0 ? void 0 : generatedOn.endsWith('Z')) ? generatedOn : "".concat(generatedOn, "Z");
    var indicatorProcessors = processors();
    var _h = (rawIndicators || []).reduce(function (acc, indicator) {
        var type = indicator.type;
        var data = indicator.data;
        var subtype = indicator.subtype;
        if (type in indicatorProcessors) {
            // @ts-ignore
            indicatorProcessors[type](acc[type], data, subtype);
        }
        return acc;
    }, { detection: [], network: [], host: [] }), detection = _h.detection, network = _h.network, host = _h.host;
    var indicators = __spreadArray(__spreadArray([], network, true), host, true);
    var indicatorsCount = getCounts(indicators);
    var horizonVerdict = getHorizonVerdict(maliciousDetermination, analysisDate);
    var horizonMscore = convertVerdictToMscore((_a = horizonVerdict === null || horizonVerdict === void 0 ? void 0 : horizonVerdict.fileAnalysisVerdict) === null || _a === void 0 ? void 0 : _a.verdict);
    var extractedFiles = rawExtractedFiles || [];
    var fileType = extractedFiles.length > 0 ? 'archive' : 'file';
    var uncompressedSize = extractedFiles.reduce(function (acc, file) { return acc + file.size; }, 0);
    var mimeTypesCount = extractedFiles.reduce(function (acc, file) {
        if (!acc[file.contentType]) {
            acc[file.contentType] = 0;
        }
        acc[file.contentType] = acc[file.contentType] + 1;
        return acc;
    }, {});
    return {
        md5: md5,
        sha1: sha1,
        sha256: sha256,
        analysisDate: analysisDate,
        mimeType: mimeType,
        size: size,
        uncompressedSize: uncompressedSize,
        detection: detection,
        indicators: indicators,
        indicatorsCount: indicatorsCount,
        horizonVerdict: horizonVerdict,
        horizonMscore: horizonMscore,
        fileType: fileType,
        extractedFiles: extractedFiles,
        mimeTypesCount: mimeTypesCount,
    };
};

/**
 * Both of these functions are taken from:
 *
 * https://ghe.eng.fireeye.com/GSI-SDE-FIIP/nautilusjs/blob/e7279e930af550fa0012666ddb652a2ad1213bf2/packages/app/src/store/actors/normalizers.js
 */
var normalizeHierarchicalLocations = function (locations) {
    // For each location item, merges the lowest hierarchical location reference
    // object with a name (meaning it's known) into the base.  If no name is
    // found on the expected objects, filter out the item.
    // @ts-ignore
    return locations.reduce(function (acc, location) {
        var _a, _b, _c;
        if (!location) {
            return acc;
        }
        if ((_a = location.country) === null || _a === void 0 ? void 0 : _a.name) {
            location = __assign(__assign({}, location), location.country);
        }
        else if ((_b = location.sub_region) === null || _b === void 0 ? void 0 : _b.name) {
            location = __assign(__assign({}, location), location.sub_region);
        }
        else if ((_c = location.region) === null || _c === void 0 ? void 0 : _c.name) {
            location = __assign(__assign({}, location), location.region);
        }
        else {
            return acc;
        }
        return __spreadArray(__spreadArray([], acc, true), [location], false);
    }, []);
};
var normalizeActor = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var industries = Array.isArray(data.industries)
        ? data.industries.map(function (industry) { return industry.name; })
        : data.industries || [];
    var aliases = Array.isArray(data.aliases)
        ? (_a = data.aliases) === null || _a === void 0 ? void 0 : _a.map(function (alias) { return alias.name; })
        : data.aliases || [];
    var malware = Array.isArray(data.malware)
        ? (_b = data.malware) === null || _b === void 0 ? void 0 : _b.map(function (malware) { return malware.name; })
        : data.malware || [];
    var targetLocations = Array.isArray((_c = data.locations) === null || _c === void 0 ? void 0 : _c.target)
        ? (_e = (_d = data.locations) === null || _d === void 0 ? void 0 : _d.target) === null || _e === void 0 ? void 0 : _e.map(function (target) { return target.name; })
        : ((_f = data.locations) === null || _f === void 0 ? void 0 : _f.target) || [];
    return {
        aliases: aliases,
        audience: data.audience,
        malware: malware,
        countryCode: (_k = (_j = (_h = (_g = data.locations) === null || _g === void 0 ? void 0 : _g.source) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.country) === null || _k === void 0 ? void 0 : _k.iso2,
        description: data.description,
        id: data.id,
        motivations: data.motivations || [],
        name: data.name,
        // @ts-ignore
        sourceLocations: (_m = normalizeHierarchicalLocations(((_l = data.locations) === null || _l === void 0 ? void 0 : _l.source) || [])) === null || _m === void 0 ? void 0 : _m.map(function (location) { return location.name; }),
        targetLocations: targetLocations,
        industries: industries,
        lastReference: data.last_activity_time,
    };
};

var useReport = function (hash, normalizer) {
    var _a = useQuery(['report', hash], function () { return fetchReportByHash(hash); }), data = _a.data, rest = __rest(_a, ["data"]);
    var report = useMemo(function () {
        if (!data) {
            return;
        }
        var reportNormalizer = normalizer || normalizeReport;
        return reportNormalizer(data);
    }, [data]);
    return __assign({ report: report }, rest);
};

var useFile = function (hash, type) {
    var _a = useQuery(['file', hash, type], function () { return fetchFileByHash(hash, type); }, {
        enabled: typeof hash === 'string',
    }), data = _a.data, rest = __rest(_a, ["data"]);
    var file = useMemo(function () {
        var _a;
        if (!((_a = data === null || data === void 0 ? void 0 : data.files) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        var rawFile = data.files[0];
        return normalizeFile(rawFile);
    }, [data]);
    return __assign({ file: file }, rest);
};

var useCase = function (sha256) {
    var _a = useQuery(['eodCase', sha256], function () { return fetchCaseBySha256(sha256); }), data = _a.data, rest = __rest(_a, ["data"]);
    var eodCase = useMemo(function () {
        var _a;
        if (!((_a = data === null || data === void 0 ? void 0 : data.cases) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        var rawCase = data.cases[0];
        return normalizeCase(rawCase);
    }, [data]);
    return __assign({ eodCase: eodCase }, rest);
};

var useArchiveContents = function (id) {
    var _a = useQuery(['archiveContents', id], function () { return fetchArchiveContentsById(id); }), data = _a.data, rest = __rest(_a, ["data"]);
    var contents = useMemo(function () {
        var _a;
        if (!((_a = data === null || data === void 0 ? void 0 : data.parentOf) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        return data.parentOf.map(normalizeFile);
    }, [data]);
    return __assign({ contents: contents }, rest);
};

var useHashType = function (hash) {
    return useMemo(function () {
        if (RegExp(/^[a-f0-9]{32}$/i).test(hash)) {
            return 'md5';
        }
        if (RegExp(/^[a-f0-9]{64}$/i).test(hash)) {
            return 'sha256';
        }
        if (RegExp(/^[a-f0-9]{40}$/i).test(hash)) {
            return 'sha1';
        }
    }, [hash]);
};

var useActor = function (id) {
    var _a = useQuery(['actor', id], function () { return fetchActorById(id); }, {
        enabled: typeof id === 'string',
    }), data = _a.data, rest = __rest(_a, ["data"]);
    var actor = useMemo(function () {
        if (!data) {
            return;
        }
        return normalizeActor(data);
    }, [data]);
    return __assign({ actor: actor }, rest);
};

var AssistanceRequest = function (_a) {
    var filename = _a.filename, sha256 = _a.sha256, createdTime = _a.createdTime, size = _a.size;
    var _b = useCase(sha256), eodCase = _b.eodCase, isFetching = _b.isFetching, isError = _b.isError;
    var queryClient = useQueryClient();
    var payload = {
        file_name: filename || sha256,
        id: sha256,
        created_at: createdTime || new Date().toString(),
        file_size: size || 0,
    };
    var openDrawer = useEodDrawer();
    var onClick = useCallback(function () {
        openDrawer(payload);
    }, [payload]);
    var onViewReport = useCallback(function () {
        openModal(eodCase.id, 'View Report', 'ServiceDetailsModal');
    }, [eodCase]);
    var invalidateEodCase = useCallback(function (hash) {
        queryClient.invalidateQueries(['eodCase', hash]);
    }, [queryClient]);
    useEodCallback(invalidateEodCase);
    if (isFetching) {
        return React.createElement(Loading, null);
    }
    if (isError || !eodCase) {
        return (React.createElement(Button, { variant: "secondary", slotLeft: React.createElement(Icon, { name: "hand-raised" }), onClick: onClick }, "Ask an Expert"));
    }
    return (React.createElement(Clickable, { onClick: onViewReport, marginRight: "spaceGapMedium" },
        React.createElement(Box, { display: "flex", gap: "spaceGapSmall" },
            React.createElement(Icon, { name: "messages", color: "colorActionPrimary" }),
            React.createElement(Box, null,
                React.createElement(H6, { margin: "0", color: "colorActionPrimary" }, "Investigation Requested"),
                React.createElement(P, { textStyle: "bodySmall", margin: "0" }, eodCase.timestamp)))));
};

var Copy = function (_a) {
    var text = _a.text;
    return (React.createElement(CopyToClipboard, { text: text },
        React.createElement(Box, { cursor: "pointer" },
            React.createElement(Icon, { name: "copy-clipboard", width: "12px", height: "12px", color: "colorActionPrimary" }))));
};

var CsvDownload = function (_a) {
    var indicators = _a.indicators, networkIndicators = _a.networkIndicators, md5 = _a.md5;
    var _b = useIndicators(networkIndicators), fetchedIndicators = _b.indicators, isFetching = _b.isFetching, isError = _b.isError;
    var csvData = useMemo(function () {
        return indicatorsToCsv(indicators, fetchedIndicators || {});
    }, [fetchedIndicators, fetchedIndicators]);
    if (isError || (indicators === null || indicators === void 0 ? void 0 : indicators.length) === 0) {
        return React.createElement(CsvDownloadButton, { disabled: true });
    }
    if (isFetching) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(CSVLink, { data: csvData, filename: "".concat(md5, "-indicators"), target: "_blank" },
        React.createElement(CsvDownloadButton, null)));
};
var CsvDownloadButton = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(Button, __assign({ variant: "secondary", slotLeft: React.createElement(Icon, { name: "download" }) }, props), "Indicators"));
};

var IndicatorsNavigationTitle = function (_a) {
    var active = _a.active, onClick = _a.onClick;
    return (React.createElement(Box, { display: "flex", alignItems: "center", gap: "spaceGapMedium" },
        React.createElement(Clickable, { onClick: function () { return onClick('all'); } },
            React.createElement(H5, { color: active ? 'colorActionPrimary' : 'colorTextPrimary' }, "All Indicators")),
        React.createElement(Tooltip, { portal: true, tooltip: "These indicators were derived from both static and dynamic analysis for this file, and may or may not be associated with malicious behavior.", instanceProps: {
                backgroundColor: 'colorBackgroundOverlay',
                color: 'colorTextMain',
                zIndex: '1',
            } },
            React.createElement(Icon, { name: "info", color: active ? 'colorActionPrimary' : undefined }))));
};

var IndicatorsNavigationGroup = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { marginBottom: "spaceGapXxLarge" }, children));
};

var IndicatorsNavigationGroupLabel = function (_a) {
    var children = _a.children;
    return (React.createElement(H5, { marginBottom: "spaceGapLarge" }, children));
};

var IndicatorsNavigationGroupItem = function (_a) {
    var active = _a.active, _b = _a.present, present = _b === void 0 ? false : _b, children = _a.children;
    return (React.createElement(P, { color: active ? 'colorActionPrimary' : 'colorTextPrimary', marginY: "spaceGapLarge", paddingLeft: "spacePaddingLarge", opacity: present ? '1' : '0.5', display: "flex", justifyContent: "space-between" }, children));
};

var IndicatorsNavigationGroupItemCount = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { as: "span", color: "white" }, children));
};

var IndicatorsNavigation = function (_a) {
    var indicatorsCount = _a.indicatorsCount, selected = _a.selected, onClick = _a.onClick;
    return (React.createElement(Widget, { width: "300px", flexShrink: "0", title: React.createElement(IndicatorsNavigationTitle, { active: selected === 'all', onClick: onClick }) },
        React.createElement(Box, { height: "1px", backgroundColor: "colorBorderDeemphasis" }),
        React.createElement(Box, { marginTop: "spaceGapXxLarge" }, INDICATOR_NAVIGATION_ITEMS.map(function (group, idx) {
            var label = group[0], items = group[1];
            return (React.createElement(IndicatorsNavigationGroup, { key: idx },
                React.createElement(IndicatorsNavigationGroupLabel, null,
                    label,
                    " Indicators"),
                items.map(function (_a, idx) {
                    var slug = _a[0], item = _a[1];
                    var present = slug in indicatorsCount;
                    return (React.createElement(Clickable, { onClick: present ? function () { return onClick(slug); } : undefined, key: idx },
                        React.createElement(IndicatorsNavigationGroupItem, { active: selected === slug, present: present },
                            item,
                            React.createElement(IndicatorsNavigationGroupItemCount, null, present ? indicatorsCount[slug] : 0))));
                })));
        }))));
};

var IndicatorsViewClickableRow = function (_a) {
    var collapsed = _a.collapsed, _b = _a.child, child = _b === void 0 ? false : _b, children = _a.children, props = __rest(_a, ["collapsed", "child", "children"]);
    var onClick = useCallback(function () {
        props.onClick(children);
    }, [collapsed, children]);
    return (React.createElement(Clickable, { display: "flex", alignItems: "center", backgroundColor: child ? 'transparent' : 'colorBackgroundPage', gap: "spaceGapMedium", paddingRight: "spacePaddingXLarge", paddingLeft: child ? '40px' : 'spacePaddingXLarge', _hover: {
            backgroundColor: 'colorBackgroundPage',
        }, onClick: onClick },
        React.createElement(Icon, { name: "chevron-".concat(collapsed ? 'top' : 'down') }),
        React.createElement(P, null, children)));
};

var IndicatorsViewNetworkRow = function (_a) {
    var type = _a.type, value = _a.children, _b = _a.child, child = _b === void 0 ? false : _b, score = _a.score, fetching = _a.fetching;
    var onClick = useCallback(function () {
        openModal(value, type, 'IndicatorModal');
    }, [type, value, score]);
    return (React.createElement(Clickable, { onClick: onClick, disabled: type === undefined },
        React.createElement(Box, { marginLeft: child ? '64px' : '40px', paddingRight: "spacePaddingXLarge", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "colorBorderDeemphasis" },
            React.createElement(Box, { display: "flex", alignItems: "center", gap: "spaceGapMedium" },
                React.createElement(P, null, value),
                fetching && React.createElement(Loading, { size: "extraSmall" }),
                typeof score === 'number' && (React.createElement(Box, { display: "flex", alignItems: "center" },
                    React.createElement(P, { variant: "body1", color: score <= 50 ? 'colorTextDeemphasis' : 'colorActionDestructive' },
                        "IC-Score: ",
                        score))),
                React.createElement(Copy, { text: value })))));
};

var IndicatorsViewRow = function (_a) {
    var task = _a.task, value = _a.children, _b = _a.child, child = _b === void 0 ? false : _b;
    return (React.createElement(Box, { marginLeft: child ? '64px' : '40px', paddingRight: "spacePaddingXLarge", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "colorBorderDeemphasis" },
        task && (React.createElement(P, { color: "colorTextDeemphasis", marginBottom: "0" }, task)),
        React.createElement(Box, { display: "flex", alignItems: "center", gap: "spaceGapMedium" },
            React.createElement(P, null, value),
            React.createElement(Copy, { text: task ? "".concat(task, ": ").concat(value) : value }))));
};

var IndicatorsView = function (_a) {
    var indicators = _a.indicators, networkIndicators = _a.networkIndicators;
    var _b = useState({}), collapsed = _b[0], setCollapsed = _b[1];
    var fetchedIndicators = useIndicators(networkIndicators).indicators;
    var expandOrCollapse = useCallback(function (name) {
        var _a;
        setCollapsed(__assign(__assign({}, collapsed), (_a = {}, _a[name] = collapsed[name] ? !collapsed[name] : true, _a)));
    }, [collapsed, setCollapsed]);
    var isCollapsed = useCallback(function (name) {
        return collapsed[name] || false;
    }, [collapsed]);
    var renderRow = useCallback(function (_a, idx) {
        var type = _a.type, items = _a.items, name = _a.name, value = _a.value, key = _a.key, queryable = _a.queryable;
        if (type === 'operation') {
            var collapsed_1 = isCollapsed(name);
            return (React.createElement(Fragment, { key: idx },
                React.createElement(IndicatorsViewClickableRow, { child: true, collapsed: collapsed_1, onClick: expandOrCollapse }, name),
                !collapsed_1 && items.map(renderRow)));
        }
        if (queryable) {
            var indicator = fetchedIndicators === null || fetchedIndicators === void 0 ? void 0 : fetchedIndicators[value];
            // @ts-ignore
            var type_1 = indicator === null || indicator === void 0 ? void 0 : indicator.type;
            var score = indicator === null || indicator === void 0 ? void 0 : indicator.mscore;
            var fetching = indicator === undefined;
            return (React.createElement(IndicatorsViewNetworkRow, { key: idx, type: type_1, score: score, fetching: fetching, child: true }, value || '""'));
        }
        return (React.createElement(IndicatorsViewRow, { key: idx, task: key, child: true }, value || '""'));
    }, [collapsed, expandOrCollapse, networkIndicators, fetchedIndicators]);
    return (React.createElement(Box, { flexGrow: "1", maxHeight: "75vh", overflowY: "scroll", padding: "spacePaddingXLarge", backgroundColor: "colorBackgroundSurface" }, indicators.map(function (_a, idx) {
        var items = _a.items, rest = __rest(_a, ["items"]);
        var rawName = rest.name;
        var name = rawName && (INDICATOR_SLUG_MAP[rawName] || rawName);
        var collapsed = isCollapsed(name);
        return (React.createElement(Fragment, { key: idx },
            React.createElement(IndicatorsViewClickableRow, { collapsed: collapsed, onClick: expandOrCollapse }, name),
            !collapsed && items.map(renderRow)));
    })));
};

var Redirect = function (_a) {
    var to = _a.to;
    useEffect(function () {
        window.location.href = to;
    }, [to]);
    return null;
};

React.createElement(P, { margin: "0" });
var FileInformation = function (_a) {
    var hashes = _a.hashes, mimeType = _a.mimeType, size = _a.size, _b = _a.uncompressedSize, uncompressedSize = _b === void 0 ? 0 : _b, type = _a.type, analyzing = _a.analyzing;
    return (React.createElement(DescriptionList, { marginTop: "0", marginBottom: "0" },
        ['sha256', 'sha1', 'md5'].map(function (key, idx) {
            var type = key;
            var value = hashes[type];
            if (!value) {
                return null;
            }
            return (React.createElement(DescriptionList.Section, { key: idx, marginBottom: "0", paddingBottom: "spaceGapSmall" },
                React.createElement(DescriptionList.Term, null,
                    React.createElement(P, { margin: "0" }, type.toUpperCase())),
                React.createElement(DescriptionList.Details, null,
                    React.createElement(P, { margin: "0" },
                        React.createElement(Box, { display: "flex", alignItems: "center", gap: "spaceGapMedium" },
                            value,
                            " ",
                            React.createElement(Copy, { text: value }))))));
        }),
        mimeType && (React.createElement(DescriptionList.Section, { marginBottom: "0", paddingBottom: "spaceGapSmall" },
            React.createElement(DescriptionList.Term, null,
                React.createElement(P, { margin: "0" }, "Mime Type")),
            React.createElement(DescriptionList.Details, null,
                React.createElement(P, { margin: "0" }, mimeType)))),
        typeof size === 'number' && (React.createElement(DescriptionList.Section, { marginBottom: "0", paddingBottom: "spaceGapSmall" },
            React.createElement(DescriptionList.Term, null,
                React.createElement(P, { margin: "0" },
                    type === 'archive' ? 'Compressed' : 'File',
                    " Size")),
            React.createElement(DescriptionList.Details, null,
                React.createElement(P, { margin: "0" },
                    filesize(size),
                    " (",
                    formatBytes(size),
                    " bytes)")))),
        type === 'archive' && (React.createElement(DescriptionList.Section, { marginBottom: "0", paddingBottom: "spaceGapSmall" },
            React.createElement(DescriptionList.Term, null,
                React.createElement(P, { margin: "0" }, "Uncompressed size")),
            React.createElement(DescriptionList.Details, null,
                React.createElement(P, { margin: "0" },
                    filesize(uncompressedSize),
                    " (",
                    formatBytes(uncompressedSize),
                    " bytes)")))),
        analyzing && React.createElement(Analyzing, null)));
};

var FileSources = function (_a) {
    var _b = _a.sources, sources = _b === void 0 ? [] : _b;
    return (React.createElement(DescriptionList, { marginTop: "0", marginBottom: "0" }, sources.map(function (source, idx) { return (React.createElement(Fragment, { key: idx },
        React.createElement(DescriptionList.Section, { marginBottom: "0", paddingBottom: "spaceGapMedium" },
            React.createElement(DescriptionList.Term, null,
                React.createElement(P, { margin: "0" }, "Source")),
            React.createElement(DescriptionList.Details, null,
                React.createElement(ListGrid.Item, null,
                    React.createElement(P, { margin: "0" }, source.source_name)))),
        React.createElement(Box, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)" },
            React.createElement(DescriptionList.Section, { marginBottom: "0", paddingBottom: "spaceGapMedium" },
                React.createElement(DescriptionList.Term, null,
                    React.createElement(P, { margin: "0" }, "First Seen")),
                React.createElement(DescriptionList.Details, null,
                    React.createElement(ListGrid.Item, null,
                        React.createElement(P, { margin: "0" }, formatShortDate(source.first_seen))))),
            React.createElement(DescriptionList.Section, { paddingBottom: "0" },
                React.createElement(DescriptionList.Term, null,
                    React.createElement(P, { margin: "0" }, "Last Seen")),
                React.createElement(DescriptionList.Details, null,
                    React.createElement(ListGrid.Item, null,
                        React.createElement(P, { margin: "0" }, formatShortDate(source.last_seen)))))))); })));
};

var fallbackData = [
    {
        label: 'N/A',
        value: 1,
    },
];
var IndicatorsChart = function (_a) {
    var countsByIndicatorType = _a.countsByIndicatorType, onClick = _a.onClick;
    var data = useMemo(function () {
        if (!countsByIndicatorType) {
            return [];
        }
        return Object.keys(countsByIndicatorType).reduce(function (acc, key) {
            var label = INDICATOR_SLUG_MAP[key];
            acc.push({
                label: label,
                value: countsByIndicatorType[key],
            });
            return acc;
        }, []);
    }, [countsByIndicatorType]);
    var totalCount = useMemo(function () {
        return Object.keys(countsByIndicatorType || {}).reduce(function (acc, key) {
            acc += countsByIndicatorType[key];
            return acc;
        }, 0);
    }, [countsByIndicatorType]);
    return (React.createElement(DonutChart, { data: totalCount > 0 ? data : fallbackData, height: 300, onClick: onClick, centerText: totalCount.toString() }));
};

var MimeTypesChart = function (_a) {
    var countsByMimeType = _a.countsByMimeType, onClick = _a.onClick;
    var data = useMemo(function () {
        if (!countsByMimeType) {
            return [];
        }
        return Object.keys(countsByMimeType).reduce(function (acc, key) {
            var label = key.length > 18 ? key.substring(0, 18) + '...' : key;
            acc.push({
                label: label,
                displayLabel: key,
                value: countsByMimeType[key],
            });
            return acc;
        }, []);
    }, [countsByMimeType]);
    var totalCount = useMemo(function () {
        return Object.keys(countsByMimeType || {}).reduce(function (acc, key) {
            acc += countsByMimeType[key];
            return acc;
        }, 0);
    }, [countsByMimeType]);
    return (React.createElement(DonutChart, { data: data, height: 300, onClick: onClick, centerText: totalCount === null || totalCount === void 0 ? void 0 : totalCount.toString() }));
};

var HashDetailsHeader = function (_a) {
    var fileType = _a.fileType, md5 = _a.md5, sha256 = _a.sha256, filename = _a.filename, createdTime = _a.createdTime, size = _a.size, indicators = _a.indicators, networkIndicators = _a.networkIndicators;
    var claims = useAuthProvider().claims;
    var userHasEodAccess = useMemo(function () {
        if (!Array.isArray(claims === null || claims === void 0 ? void 0 : claims.isl)) {
            return false;
        }
        return claims.isl.some(function (claim) { return claim === 'INTEL_EOD' || claim === 'INTEL_AA'; });
    }, [claims]);
    return (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", marginY: "spaceGapLarge" },
        React.createElement(Box, { display: "flex", alignItems: "center", gap: "spaceGapLarge" },
            React.createElement(Icon, { name: "fingerprint", size: "lg" }),
            React.createElement(H2, { margin: "0", textTransform: 'none' },
                fileType === 'archive' ? 'Archive' : 'File',
                ": ",
                md5.toLowerCase())),
        React.createElement(Box, { display: "flex", alignItems: "center", gap: "spaceGapMedium" },
            userHasEodAccess && sha256 && (React.createElement(AssistanceRequest, { sha256: sha256, createdTime: createdTime, filename: filename, size: size })),
            React.createElement(CsvDownload, { indicators: indicators, networkIndicators: networkIndicators, md5: md5 }))));
};

var HashDetailsIndicators = function (_a) {
    var rawIndicators = _a.indicators, indicatorsCount = _a.indicatorsCount, networkIndicators = _a.networkIndicators;
    var _b = useState('all'), currentIndicatorType = _b[0], setCurrentIndicatorType = _b[1];
    var indicators = useMemo(function () {
        if (currentIndicatorType === 'all') {
            return rawIndicators;
        }
        return rawIndicators.filter(function (indicator) { return indicator.name === currentIndicatorType; });
    }, [rawIndicators, currentIndicatorType]);
    var onNavigationClick = useCallback(function (slug) {
        setCurrentIndicatorType(slug);
    }, [currentIndicatorType]);
    return (React.createElement(Box, { display: "flex", gap: "spaceGapLarge" },
        React.createElement(IndicatorsNavigation, { indicatorsCount: indicatorsCount, selected: currentIndicatorType, onClick: onNavigationClick }),
        React.createElement(IndicatorsView, { indicators: indicators, networkIndicators: networkIndicators })));
};

var HashDetailsContentsFile = function (_a) {
    var _b, _c;
    var file = _a.file, _d = _a.hasEodAccess, hasEodAccess = _d === void 0 ? true : _d;
    var sha256 = file.sha256, md5 = file.md5;
    var _e = useIndicator(md5), indicator = _e.indicator, fetchingIndicator = _e.isFetching;
    var _f = useReport(sha256, normalizeReport$1), report = _f.report, fetchingReport = _f.isFetching;
    var _g = useCase(sha256), eodCase = _g.eodCase, fetchingCase = _g.isFetching;
    var actorId = ((_c = (_b = indicator === null || indicator === void 0 ? void 0 : indicator.associations) === null || _b === void 0 ? void 0 : _b.threatActors) === null || _c === void 0 ? void 0 : _c[0]) || null;
    var _h = useActor(actorId), actor = _h.actor, fetchingActor = _h.isFetching;
    return (React.createElement(File, { file: file, indicator: indicator, report: report, actor: actor, eodCase: eodCase, fetchingReport: fetchingReport, fetchingIndicator: fetchingIndicator, fetchingActor: actorId && fetchingActor, fetchingCase: fetchingCase, hasEodAccess: hasEodAccess, 
        // those props are passed to file container / box
        backgroundColor: "colorFillMain", minHeight: "195px" }));
};

var title = 'Archive Contents';
var HashDetailsContents = function (_a) {
    var id = _a.id;
    var _b = useArchiveContents(id), contents = _b.contents, isFetching = _b.isFetching, isError = _b.isError;
    var claims = useAuthProvider().claims;
    var userHasEodAccess = useMemo(function () {
        if (!Array.isArray(claims === null || claims === void 0 ? void 0 : claims.isl)) {
            return false;
        }
        return claims.isl.some(function (claim) { return claim === 'INTEL_EOD' || claim === 'INTEL_AA'; });
    }, [claims]);
    var rowRenderer = useCallback(function (row) {
        var index = row.index, style = row.style, key = row.key;
        return (React.createElement(Box, { key: key, style: style },
            React.createElement(HashDetailsContentsFile, { file: contents[index] })));
    }, [contents, userHasEodAccess]);
    if (isFetching) {
        return (React.createElement(Box, { display: "flex", justifyContent: "center" },
            React.createElement(Loading, null)));
    }
    if (isError || !contents) {
        return React.createElement(Widget, { title: title }, "Failed to fetch contents");
    }
    return (React.createElement(WindowScroller, null, function (_a) {
        var height = _a.height, scrollTop = _a.scrollTop, registerChild = _a.registerChild;
        return (React.createElement(Widget, { title: title },
            React.createElement(AutoSizer, { disableHeight: true }, function (_a) {
                var width = _a.width;
                return (React.createElement(List, { ref: registerChild, width: width, height: height, autoHeight: true, scrollTop: scrollTop, rowRenderer: rowRenderer, rowHeight: 211, rowCount: contents.length }));
            })));
    }));
};

var typeTargetMap = {
    'threat-actor': 'actors',
    malware: 'malwares',
};
var HashDetailsAssociations = function (_a) {
    var attributed_associations = _a.attributed_associations, campaigns = _a.campaigns;
    var _b = useMemo(function () {
        return attributed_associations.reduce(function (acc, currAssociation) {
            var target = typeTargetMap[currAssociation.type];
            if (!target) {
                return acc;
            }
            acc[target].push(currAssociation);
            return acc;
        }, {
            malwares: [],
            actors: [],
        });
    }, [attributed_associations]), actors = _b.actors, malwares = _b.malwares;
    if (actors.length === 0 && malwares.length === 0 && campaigns.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        actors.length > 0 && (React.createElement(Widget, { title: "Actor Attribution" }, actors.map(function (actor, idx) { return (React.createElement(ActorDetails, { id: actor.id, key: idx })); }))),
        campaigns.length > 0 && (React.createElement(Widget, { title: "Campaign Associations" }, campaigns.map(function (campaign, idx) { return (React.createElement(CampaignDetails, { id: campaign.id, key: idx })); }))),
        malwares.length > 0 && (React.createElement(Widget, { title: "Malware Associations" }, malwares.map(function (malware, idx) { return (React.createElement(MalwareDetails, { id: malware.id, key: idx })); })))));
};

var HashDetails$1 = function (_a) {
    var _b;
    var indicator = _a.indicator, hash = _a.hash, _c = _a.initialTab, initialTab = _c === void 0 ? 'summary' : _c;
    var _d = useHashDetails({
        indicator: indicator,
        hash: hash,
    }), report = _d.report, file = _d.file, hashes = _d.hashes, analyzing = _d.analyzing, loading = _d.loading, notFound = _d.notFound;
    var tabState = useTabState({ selectedId: initialTab });
    var setSelectedId = tabState.setSelectedId;
    var setTabToExtractedIndicators = useCallback(function () {
        setSelectedId('extracted indicators');
    }, [setSelectedId]);
    var setTabToArchiveContents = useCallback(function () {
        setSelectedId('archive contents');
    }, [setSelectedId]);
    var showExtractedIndicators = useMemo(function () {
        var _a;
        if (!((_a = report === null || report === void 0 ? void 0 : report.indicators) === null || _a === void 0 ? void 0 : _a.length)) {
            return false;
        }
        return true;
    }, [report]);
    var showArchiveContents = useMemo(function () {
        if (!report || !file) {
            return false;
        }
        return (report === null || report === void 0 ? void 0 : report.fileType) === 'archive' && (file === null || file === void 0 ? void 0 : file.id) ? true : false;
    }, [report, file]);
    useEffect(function () {
        if (showArchiveContents) {
            setTabToArchiveContents();
        }
    }, [showArchiveContents, setTabToArchiveContents]);
    var networkIndicators = useMemo(function () {
        var _a;
        return (_a = report === null || report === void 0 ? void 0 : report.indicators) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, indicator) {
            if (!indicator.name.match('connections|http')) {
                return acc;
            }
            acc.push.apply(acc, indicator.items.map(function (item) { return item.value; }));
            return acc;
        }, ['']);
    }, [report]);
    if (loading) {
        return (React.createElement(Box, { textAlign: "center" },
            React.createElement(Loading, { label: "Loading..", size: "large" })));
    }
    if (notFound) {
        return React.createElement(Redirect, { to: "/404" });
    }
    var _e = report || {}, mimeType = _e.mimeType, size = _e.size, fileType = _e.fileType, uncompressedSize = _e.uncompressedSize, analysisDate = _e.analysisDate, mimeTypesCount = _e.mimeTypesCount;
    var _f = indicator || {}, sources = _f.sources, associations = _f.attributed_associations, _g = _f.campaigns, campaigns = _g === void 0 ? [] : _g;
    return (React.createElement(Box, null,
        React.createElement(HashDetailsHeader, { fileType: fileType, md5: hashes.md5 || hash, sha256: hashes.sha256, filename: file === null || file === void 0 ? void 0 : file.filename, createdTime: file === null || file === void 0 ? void 0 : file.createdTime, size: (file === null || file === void 0 ? void 0 : file.size) || (report === null || report === void 0 ? void 0 : report.size), indicators: report === null || report === void 0 ? void 0 : report.indicators, networkIndicators: networkIndicators }),
        React.createElement(React.Fragment, null,
            React.createElement(TabList, __assign({}, tabState),
                React.createElement(Tab, __assign({}, tabState, { id: "summary" }), "Summary"),
                showExtractedIndicators && (React.createElement(Tab, __assign({}, tabState, { id: "extracted indicators" }), "Extracted Indicators")),
                showArchiveContents && (React.createElement(Tab, __assign({}, tabState, { id: "archive contents" }), "Archive Contents"))),
            React.createElement(TabPanel, __assign({}, tabState),
                React.createElement(Box, { display: "flex", gap: "spaceGapLarge" },
                    React.createElement(Box, { display: "flex", flexDirection: "column", gap: "spaceGapLarge", width: "66%", flexShrink: "0" },
                        React.createElement(Score.Panel, null,
                            React.createElement(Score, { score: (_b = indicator === null || indicator === void 0 ? void 0 : indicator.mscore) !== null && _b !== void 0 ? _b : report === null || report === void 0 ? void 0 : report.horizonMscore, verdict: (indicator === null || indicator === void 0 ? void 0 : indicator.verdict) || (report === null || report === void 0 ? void 0 : report.horizonVerdict) })),
                        React.createElement(Widget, { title: "File Information" },
                            React.createElement(Box, { marginTop: "spaceGapXxLarge" },
                                React.createElement(FileInformation, { hashes: hashes, mimeType: mimeType, size: size, uncompressedSize: uncompressedSize, type: fileType, analyzing: analyzing }),
                                (sources === null || sources === void 0 ? void 0 : sources.length) > 0 && (React.createElement(React.Fragment, null,
                                    React.createElement(Box, { width: "100%", height: "1px", backgroundColor: "colorBorderMain", marginTop: "spaceGapXxLarge", marginBottom: "spaceGapXxLarge" }),
                                    React.createElement(FileSources, { sources: sources }))))),
                        (associations === null || associations === void 0 ? void 0 : associations.length) > 0 && (React.createElement(Widget, { title: "Associations" },
                            React.createElement(Box, { marginTop: "spaceGapXxLarge" },
                                React.createElement(AssociationsDetails, { associations: associations, campaigns: campaigns || [], renderChildrenAsLinks: true })))),
                        !analyzing && report && (React.createElement(Widget, { title: "Analysis Details" },
                            React.createElement(Box, { marginTop: "spaceGapXxLarge" },
                                React.createElement(AnalysisDetails, { analysisDate: analysisDate, owner: file === null || file === void 0 ? void 0 : file.owner, detections: report.detection }))))),
                    React.createElement(Box, { display: "flex", flexDirection: "column", gap: "spaceGapLarge", flexGrow: "1" },
                        React.createElement(HashDetailsAssociations, { attributed_associations: (indicator === null || indicator === void 0 ? void 0 : indicator.attributed_associations) || [], campaigns: campaigns || [] }),
                        fileType === 'archive' ? (React.createElement(Widget, { title: "Mime Types of Content Files" },
                            React.createElement(MimeTypesChart, { countsByMimeType: mimeTypesCount, onClick: setTabToArchiveContents }))) : (React.createElement(Widget, { title: "Extracted Indicators" },
                            React.createElement(IndicatorsChart, { countsByIndicatorType: report === null || report === void 0 ? void 0 : report.indicatorsCount, onClick: setTabToExtractedIndicators })))))),
            showExtractedIndicators && (React.createElement(TabPanel, __assign({}, tabState),
                React.createElement(HashDetailsIndicators, { indicators: report === null || report === void 0 ? void 0 : report.indicators, indicatorsCount: report === null || report === void 0 ? void 0 : report.indicatorsCount, networkIndicators: networkIndicators }))),
            showArchiveContents && (React.createElement(TabPanel, __assign({}, tabState),
                React.createElement(HashDetailsContents, { id: file === null || file === void 0 ? void 0 : file.id }))))));
};

var HashSummaryColumn = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { borderTopWidth: "1px", borderTopColor: "colorBorderMain", borderTopStyle: "solid", paddingTop: "spacePaddingXLarge", display: "flex", flexDirection: "column", gap: "spaceGapXLarge" }, children));
};

var HashSummary$1 = function (_a) {
    var _b;
    var indicator = _a.indicator, hash = _a.hash;
    var _c = useHashDetails({
        indicator: indicator,
        hash: hash,
    }), notFound = _c.notFound, report = _c.report, file = _c.file, hashes = _c.hashes, analyzing = _c.analyzing, loading = _c.loading;
    if (loading) {
        return (React.createElement(Box, { textAlign: "center" },
            React.createElement(Loading, { size: "large" })));
    }
    if (notFound) {
        return (React.createElement(Box, null,
            React.createElement(P, { textStyle: "bodySmall" }, "No data for this indicator was found")));
    }
    var _d = report || {}, mimeType = _d.mimeType, size = _d.size, fileType = _d.fileType, uncompressedSize = _d.uncompressedSize, analysisDate = _d.analysisDate;
    var _e = indicator || {}, sources = _e.sources, associations = _e.attributed_associations;
    return (React.createElement(Box, { display: "flex", flexDirection: "column", gap: "spaceGapXLarge" },
        React.createElement(Score, { score: (_b = indicator === null || indicator === void 0 ? void 0 : indicator.mscore) !== null && _b !== void 0 ? _b : report === null || report === void 0 ? void 0 : report.horizonMscore, verdict: (indicator === null || indicator === void 0 ? void 0 : indicator.verdict) || (report === null || report === void 0 ? void 0 : report.horizonVerdict), summaryOnly: true }),
        React.createElement(HashSummaryColumn, null,
            React.createElement(Text, { variant: "heading5" }, "File Information"),
            React.createElement(FileInformation, { hashes: hashes, mimeType: mimeType, size: size, uncompressedSize: uncompressedSize, type: fileType, analyzing: analyzing })),
        (sources === null || sources === void 0 ? void 0 : sources.length) > 0 && (React.createElement(HashSummaryColumn, null,
            React.createElement(FileSources, { sources: sources }))),
        !analyzing && report && (React.createElement(HashSummaryColumn, null,
            React.createElement(Text, { variant: "heading5" }, "Analysis Details"),
            React.createElement(AnalysisDetails, { analysisDate: analysisDate, owner: file === null || file === void 0 ? void 0 : file.owner, detections: report.detection }))),
        (associations === null || associations === void 0 ? void 0 : associations.length) && (React.createElement(HashSummaryColumn, null,
            React.createElement(Text, { variant: "heading5" }, "Associations"),
            React.createElement(AssociationsDetails, { associations: associations })))));
};

// create a client
var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: function (failureCount, error) {
                if (failureCount === 3) {
                    return false;
                }
                var errorCode = parseInt(error.message);
                if (errorCode >= 500 && errorCode <= 599) {
                    return true;
                }
                return false;
            },
            refetchOnWindowFocus: false,
        },
    },
});
// should be used as a page
var HashDetails = function (props) { return (React.createElement(QueryClientProvider, { client: queryClient },
    React.createElement(HashDetails$1, __assign({}, props)))); };
// should be used by modals, search drawers etc
var HashSummary = function (props) { return (React.createElement(QueryClientProvider, { client: queryClient },
    React.createElement(HashSummary$1, __assign({}, props)))); };

export { HashDetails, HashSummary };
